import React from 'react';
import htmr from 'htmr';
import ReactPlayer from 'react-player'

function Video(props) {
    
    return (
        <div className="flexcolumn displayflex flex1 quiz-container mb30">
            <div style={{ fontSize: 16 }}>
                {htmr(props.data.question)}
            </div>
            <div >
                <ReactPlayer url={props.data.videoUrl} controls={true} width={'100%'} height={'auto'} />
            </div>
        </div>
    );
}

export default Video;